import { render } from "./ViewPanel.vue?vue&type=template&id=a8bf4fe0&scoped=true&ts=true"
import script from "./ViewPanel.vue?vue&type=script&lang=ts"
export * from "./ViewPanel.vue?vue&type=script&lang=ts"

import "./ViewPanel.vue?vue&type=style&index=0&id=a8bf4fe0&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8bf4fe0"]])

export default __exports__